"use strict";

var VaFilter = function () {
  var getFilterConfigs = function () {
    return {};
  };

  return {
    getFilterConfigs,
  };
};

module.exports = VaFilter();
